import React, { useContext } from "react";
import prefixStyles from "nx-components/utils/prefixStyles";
import Button from "nx-components/Button";
import { Divider } from "nx-components/ItemList";
import RichLabel from "nx-components/RichLabel";
import { IconSad } from "nx-components/Icons";
import LanguageContext from "nx-components/ContextWrappers/LanguageContext";

const styles = prefixStyles({
  outerWrapper: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
  },
  innerWrapper: {
    margin: "1.5em",
    maxWidth: "25em",
  },
  richLabelWrapper: {
    margin: "1em 0",
  },
  richLabelLabelWrapper: {
    padding: "0.25em 0",
  },
});

const ErrorPage = () => {
  const languageContext = useContext(LanguageContext);
  const language = languageContext.localeSet.nexia_mobile.pages.ErrorPage;

  return (
    <div style={styles.outerWrapper}>
      <div style={styles.innerWrapper}>
        <div style={styles.richLabelWrapper}>
          <RichLabel
            icon={<IconSad />}
            label={
              <div style={styles.richLabelLabelWrapper}>
                {language.somethingWentWrong}
              </div>
            }
          />
        </div>
        <Divider />
        <p style={{ margin: "1em 0" }}>{language.teamNotified}</p>
        <Button full onTap={() => window.location.reload()}>
          {language.restartTheApp}
        </Button>
      </div>
    </div>
  );
};

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/components/Pages/ErrorPage.jsx